import React, {useState, useEffect} from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import VisualSelectorInstance from './VisualSelectorInstance';

const VisualSelectorAddingModal = ({ isOpen, toggle, loading, dataForVS, connectItemToCompany, companyId, setInputValue }) => {
    const [alteredDataForVs, setAlteredDataForVs] = useState(null);

    useEffect(() => {

    }, []);

    return (
        <Modal style={{ maxWidth: 'none', width: '99%', margin: '5px auto' }} isOpen={isOpen}>
            <ModalHeader toggle={toggle}>
                <strong>Visual Selector</strong>
            </ModalHeader>
            <ModalBody style={{ padding: '0' }}>
                <VisualSelectorInstance
                    loading={loading}
                    dataForVS={dataForVS}
                    toggle={toggle}
                    connectItemToCompany={connectItemToCompany}
                    companyId={companyId}
                    setInputValue={setInputValue}
                />
            </ModalBody>
        </Modal>
    );
};

export default VisualSelectorAddingModal;